import axios from '@/utils/request'
import base from '@/api/base'

/**
 * IP 黑名单（/v1/admin/ip-blacklist/**）
 */

export function listIpBlacklist(params) {
  return axios.get(`${base.url}/service/v1/admin/ip-blacklist`, { params })
}

export function addIpBlacklist(body) {
  return axios.post(`${base.url}/service/v1/admin/ip-blacklist`,
    JSON.stringify(body), { headers: { 'Content-Type': 'application/json' } })
}

export function removeIpBlacklist(id) {
  return axios.delete(`${base.url}/service/v1/admin/ip-blacklist/${id}`)
}